import { QuickstartTemplate } from "components/templates"

const Quickstart = (): JSX.Element => {
  return <QuickstartTemplate />
}

export default Quickstart
